// Verdict banner (RESTYLE §2): a filled square chip, glyph + CAPS word (+ score), on-colour text chosen for contrast.
//   <VerdictBanner v score? of? size? partial? label? title? className? />
//       v: malicious | suspicious | benign | pending (pending = dashed outline, no fill)
//       size: lg (32px; beside the report title, pinned in the figure index) | sm (22px; the Analyses verdict cell)
//       partial: the run stopped before collection (cancelled, failed, stream short): no fill, a dashed edge in the
//                verdict hue, the hue's text step, "BENIGN · PARTIAL". Only a completed run wears the filled banner.
//       of: show "/100" after the score · label: override the word (e.g. "not scored")
//   The lens hero numeral stays in the verdict colour; this is the label beside the title and in lists.
import { VerdictGlyph, type VerdictLabel } from "./Glyphs";
import { cx } from "./cx";

export function VerdictBanner({
  v,
  score,
  of,
  size = "lg",
  partial,
  label,
  title,
  className,
}: {
  v: VerdictLabel;
  score?: number | null;
  of?: boolean;
  size?: "sm" | "lg";
  partial?: boolean;
  label?: string;
  title?: string;
  className?: string;
}) {
  const isPartial = !!partial && v !== "pending";
  return (
    <span className={cx("vb", `vb--${v}`, size === "sm" && "vb--sm", isPartial && "vb--partial", className)} title={title}>
      <span className="vb-w">
        <VerdictGlyph v={v} />
        {label ?? (isPartial ? `${v} · partial` : v)}
      </span>
      {score !== undefined && score !== null && (
        <span className="vb-sc">
          <span className="sr-only">score </span>
          {score}
          {of && <small>/100</small>}
        </span>
      )}
    </span>
  );
}
